"use client";

import { c as _c } from "react/compiler-runtime";
import { useRef, useState } from "react";
import { useClickAway, useKeyPressEvent } from "react-use";
import GroupCreateIdentitiesSearchItems from "./GroupCreateIdentitiesSearchItems";
import type { CommunityMemberMinimal } from "@/entities/IProfile";
import { getRandomObjectId } from "@/helpers/AllowlistToolHelpers";
export default function GroupCreateIdentitiesSearch(t0) {
  const $ = _c(30);
  const {
    selectedWallets,
    onIdentitySelect,
    placeholder: t1,
    label: t2,
    hideLabel: t3,
    inputClassName: t4,
    iconClassName: t5
  } = t0;
  const placeholder = t1 === undefined ? " " : t1;
  const label = t2 === undefined ? "Identity" : t2;
  const hideLabel = t3 === undefined ? false : t3;
  const inputClassName = t4 === undefined ? "" : t4;
  const iconClassName = t5 === undefined ? "" : t5;
  const [isOpen, setIsOpen] = useState(false);
  let t6;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = newV => {
      if (newV) {
        setIsOpen(true);
      }
    };
    $[0] = t6;
  } else {
    t6 = $[0];
  }
  const onFocusChange = t6;
  const [searchCriteria, setSearchCriteria] = useState(null);
  let t7;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = newV_0 => {
      setSearchCriteria(newV_0);
    };
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const onSearchCriteriaChange = t7;
  const wrapperRef = useRef(null);
  let t8;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setIsOpen(false);
    $[2] = t8;
  } else {
    t8 = $[2];
  }
  useClickAway(wrapperRef, t8);
  let t9;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => setIsOpen(false);
    $[3] = t9;
  } else {
    t9 = $[3];
  }
  useKeyPressEvent("Escape", t9);
  let t10;
  if ($[4] !== onIdentitySelect) {
    t10 = item => {
      onIdentitySelect(item);
      setIsOpen(false);
      setSearchCriteria(null);
    };
    $[4] = onIdentitySelect;
    $[5] = t10;
  } else {
    t10 = $[5];
  }
  const onSelect = t10;
  let t11;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = getRandomObjectId();
    $[6] = t11;
  } else {
    t11 = $[6];
  }
  const randomId = t11;
  const t12 = searchCriteria ?? "";
  let t13;
  let t14;
  let t15;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = e => onSearchCriteriaChange(e.target.value);
    t14 = () => onFocusChange(true);
    t15 = () => onFocusChange(false);
    $[7] = t13;
    $[8] = t14;
    $[9] = t15;
  } else {
    t13 = $[7];
    t14 = $[8];
    t15 = $[9];
  }
  const t16 = `tw-peer tw-form-input tw-block tw-w-full tw-appearance-none tw-rounded-lg tw-border-0 tw-border-iron-700 tw-bg-iron-950 tw-pb-3 tw-pl-10 tw-pr-4 tw-pt-3 tw-text-base tw-font-medium tw-text-white tw-caret-primary-300 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-700 tw-transition tw-duration-300 tw-ease-out placeholder:tw-text-iron-500 hover:tw-ring-iron-650 focus:tw-border-blue-500 focus:tw-bg-iron-900 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400 sm:tw-text-sm ${inputClassName}`;
  let t17;
  if ($[10] !== placeholder || $[11] !== t12 || $[12] !== t16) {
    t17 = <input type="text" value={t12} onChange={t13} onFocus={t14} onBlur={t15} id={randomId} className={t16} placeholder={placeholder} />;
    $[10] = placeholder;
    $[11] = t12;
    $[12] = t16;
    $[13] = t17;
  } else {
    t17 = $[13];
  }
  const t18 = `tw-pointer-events-none tw-absolute tw-left-3 tw-top-3.5 tw-h-5 tw-w-5 tw-text-iron-300 ${iconClassName}`;
  let t19;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <path fillRule="evenodd" d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z" clipRule="evenodd" />;
    $[14] = t19;
  } else {
    t19 = $[14];
  }
  let t20;
  if ($[15] !== t18) {
    t20 = <svg className={t18} viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">{t19}</svg>;
    $[15] = t18;
    $[16] = t20;
  } else {
    t20 = $[16];
  }
  const t21 = `tw-absolute tw-start-1 tw-top-2 tw-z-10 tw-ml-7 tw-origin-[0] -tw-translate-y-4 tw-scale-75 tw-transform tw-cursor-text tw-rounded-lg tw-bg-iron-900 tw-px-2 tw-text-md tw-font-medium tw-text-iron-500 tw-duration-300 peer-placeholder-shown:tw-top-1/2 peer-placeholder-shown:-tw-translate-y-1/2 peer-placeholder-shown:tw-scale-100 peer-focus:tw-top-2 peer-focus:-tw-translate-y-4 peer-focus:tw-scale-75 peer-focus:tw-bg-iron-900 peer-focus:tw-px-2 peer-focus:tw-text-primary-400 rtl:peer-focus:tw-left-auto rtl:peer-focus:tw-translate-x-1/4 ${hideLabel ? "tw-sr-only" : ""}`;
  let t22;
  if ($[17] !== label || $[18] !== t21) {
    t22 = <label htmlFor={randomId} className={t21}>{label}</label>;
    $[17] = label;
    $[18] = t21;
    $[19] = t22;
  } else {
    t22 = $[19];
  }
  let t23;
  if ($[20] !== isOpen || $[21] !== onSelect || $[22] !== searchCriteria || $[23] !== selectedWallets) {
    t23 = <GroupCreateIdentitiesSearchItems open={isOpen} searchCriteria={searchCriteria} onSelect={onSelect} selectedWallets={selectedWallets} />;
    $[20] = isOpen;
    $[21] = onSelect;
    $[22] = searchCriteria;
    $[23] = selectedWallets;
    $[24] = t23;
  } else {
    t23 = $[24];
  }
  let t24;
  if ($[25] !== t17 || $[26] !== t20 || $[27] !== t22 || $[28] !== t23) {
    t24 = <div className="tw-group tw-relative tw-w-full" ref={wrapperRef}>{t17}{t20}{t22}{t23}</div>;
    $[25] = t17;
    $[26] = t20;
    $[27] = t22;
    $[28] = t23;
    $[29] = t24;
  } else {
    t24 = $[29];
  }
  return t24;
}